module.exports = __webpack_public_path__ + "media/images/home-page/3-5-0e8fd6e492759a5366c2ac3b7b10aa7c.png";